import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Select from 'react-select';

class ScheduleGradeMainChangeGroupTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_group_id: this.props.schedule_grade_group_id,
      groups_select: this.props.groups_select,
      base_setting_group_id: this.props.base_setting_group_id,
    };

    this.edit = this.edit.bind(this);
  }
  
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // Adiciono uma aeronave na escala
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var confirm = window.confirm('Tem certeza que gostaria associar este grupo ao grupo da máscara de base?');
    if (confirm) {
      var datasave = {
        id: this.props.schedule_grade_group_id,
        base_setting_group_id: this.state.base_setting_group_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/associar/grupo/mascara', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }    
  }    

  render() {
    var self = this;
    return (
    <form onSubmit={this.edit}>
      <RequestApi ref={'request_api'} />
      <div className="row">
        <div className="col-md-9">
          <Select
            className="form-field-name"
            name="base_setting_group_id"
            value={this.state.base_setting_group_id}
            searchable={true}
            placeholder={''}
            onChange={this.handleSelectChange.bind(this, 'base_setting_group_id')}
            options={this.state.groups_select}
            required
          />    
        </div>
        <div className="col-md-3">
          <button type="submit" className="btn btn-success btn-block"><i className="fa fa-fw fa-check"></i></button>
        </div>
      </div>
    </form>
    );
  }
}

export default ScheduleGradeMainChangeGroupTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeMainChangeGroupTab.js